// extracted by mini-css-extract-plugin
export var aggregationCell = "_48-e";
export var aggregationRow = "_48-d";
export var borderlessSpinnerContainer = "_48-2";
export var closeIcon = "_48-6";
export var expandIcon = "_48-7";
export var expanded = "_48-8";
export var filterDropdown = "_48-9";
export var filterDropdownHeader = "_48-c";
export var filterDropdownItem = "_48-b";
export var filterDropdownModal = "_48-a _48-9";
export var filterItem = "_48-4";
export var normalCellWithAdjustableBorder = "_48-5";
export var spinner = "_48-0";
export var spinnerContainer = "_48-1";
export var tableContainer = "_48-3";